import { Component, EventEmitter, Input, OnInit, Output, ViewChild, inject } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { ProductService } from '../../services/product/product.service';
import * as _ from 'lodash';

import { SearchWrapComponent } from '@components/search-wrap/search-wrap.component';
import { NavigationService } from '../../services/navigation/navigation.service';
import { TranslateService } from '@ngx-translate/core';
import { FridgeService } from '../../services/fridge/fridge.service';

@Component({
    selector: 'app-category-picker',
    templateUrl: './category-picker.component.html',
    styleUrls: ['./category-picker.component.scss'],
    standalone: false
})
export class CategoryPickerComponent implements OnInit {
  userService = inject(UserService);
  productService = inject(ProductService);
  navigation = inject(NavigationService);
  i18n = inject(TranslateService);
  fridgeService = inject(FridgeService);

  @ViewChild(SearchWrapComponent) searchWrap: SearchWrapComponent;
  @Input() showCategories!: boolean;
  @Input() selectedCategoryId: any;
  @Input() merchantId: string;
  @Output() select: EventEmitter<string> = new EventEmitter();
  @Output() back = new EventEmitter();

  newCategoryName = '';

  filteredCategoryList = [];
  isSearch = false;

  ngOnInit() {}

  selectCategory(id: string) {
    this.searchWrap.reset();
    this.select.emit(id);
    this.search('');
    this.selectedCategoryId = id;
  }

  search(searchQuery) {
    if (searchQuery.length === 0) {
      this.isSearch = false;
      this.filteredCategoryList = this.productService.categories;
      return;
    }
    this.isSearch = true;
    this.filteredCategoryList = _.filter(this.productService.categories, (category) => {
      return category.name.toLowerCase().includes(searchQuery.toLowerCase());
    });
  }

  onBack() {
    this.back.emit();
  }

  async addCategory() {
    const category = await this.productService.createCategory({
      name: this.newCategoryName,
      merchantId: this.merchantId || this.userService.getUserData().merchantId,
    });
    this.select.emit(category._id as unknown as string);
    this.newCategoryName = '';
  }
}
